import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
function NodeItem(props) {
  const {
    treeNode = {},
    onSelectHandler = () => {},
    selectable = true
  } = props;
  const {
    id = '',
    nodeItem = () => {}
  } = treeNode;
  const nodeItemClasses = classNames({
    [treeStyles['sib-tree-view__nodeItem']]: true
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    React.createElement("div", {
      "data-testid": id,
      role: "button",
      tabIndex: null,
      className: nodeItemClasses,
      onClick: e => {
        if (selectable) {
          onSelectHandler(e);
        }
      },
      onKeyDown: null
    }, nodeItem && nodeItem())
  );
}
NodeItem.propTypes = {
  treeNode: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    nodeItem: PropTypes.func,
    children: PropTypes.array
  }),
  selectable: PropTypes.bool,
  onSelectHandler: PropTypes.func
};
export default NodeItem;